var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatar1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "108px",
    height: "108px",
    viewBox: "0 0 108 108",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "avatar") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 54,
    cy: 54,
    r: 54
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Personal-1-mixed",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-811.000000, -274.000000)",
    id: "hero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(290.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bio",
    transform: "translate(470.000000, 274.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "avatar",
    transform: "translate(51.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Oval",
    fill: "#FFD15C",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.000000, 17.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.6356295,80.7525616 C43.853241,75.8516712 39.9729692,69.7628082 40.9789174,61 L28.0210826,61 C29.0270308,69.7628082 25.1474084,75.8516712 13.3637211,80.7525616 C1.58068311,85.6534521 0,91 0,91 L69,91 C69,91 67.4193169,85.6534521 55.6356295,80.7525616",
    id: "Fill-31",
    fill: "#6C6CE5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9996781,83 C39.903661,83 44.2430131,79.8316742 46,75.0533937 C45.6433233,74.7085973 45.3117556,74.3570136 44.9982149,74.0006787 L44.9988587,74.0006787 C43.6204384,78.4361991 39.6680226,81.6425339 34.9996781,81.6425339 C30.3319774,81.6425339 26.3789178,78.4361991 25.0011413,74.0006787 L25.0017851,74 C24.6888882,74.3563348 24.3560329,74.7085973 24,75.0533937 C25.7576307,79.8316742 30.0956952,83 34.9996781,83",
    id: "Fill-32",
    fill: "#FFFFFE",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45,73.5226631 C41.8642349,70.0260667 40.8546087,65.9443799 41.4238112,61 L28.5761888,61 C29.1447474,65.9443799 28.1351212,70.0260667 25,73.5226631 C26.3785776,77.862693 30.3314446,81 34.9996781,81 C39.6685554,81 43.6214224,77.862693 45,73.5226631",
    id: "Fill-33",
    fill: "#E46B6A",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45,73.6207095 C41.873067,70.0967495 40.8666237,65.981665 41.4349227,61 L28.5786082,61 C29.1475515,65.9897075 28.1372423,70.1088133 25,73.6374647 L25.0386598,73.747379 C27.7158505,74.5536407 30.8885309,75 34.6643041,75 C38.7835052,75 42.1849227,74.5073962 45,73.6207095",
    id: "Fill-34",
    fill: "#E05A5B",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8128935,51 C10.8128935,51 9.71814547,36.6818855 22.8518444,31.6782819 C35.9855433,26.6746784 43.646813,22.8677874 44.194187,12.9696098 C44.194187,12.9696098 48.2985089,21.5986061 44.194187,27.435926 C44.194187,27.435926 49.1192421,27.6898928 49.9399754,24.3902827 C49.9399754,24.3902827 51.8554567,29.8293512 51.0347235,31.6782819 C51.0347235,31.6782819 53.4969233,31.4967838 53.770938,27.9438597 L55.4124046,46.7250005 L56.5071526,51 L60.5190437,37.706893 C60.5190437,37.706893 71.0155142,12.9696098 48.8281834,6.5016165 C48.8281834,6.5016165 30.1945227,-9.61907492 10.7906052,8.90809911 C10.7906052,8.90809911 -4.86953616,21.3570439 5.61382359,40.8876807 L10.8128935,51",
    id: "Fill-35",
    fill: "#302C3F",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1316592,8.79117329 C11.1316592,8.79117329 4.99310492,13.6318111 3,22 C5.01594666,18.6567191 11.9206782,8.44196183 22.7248209,5.23527286 C35.7100234,1.3797722 49,6.41627766 49,6.41627766 C49,6.41627766 30.4492445,-9.49281698 11.1316592,8.79117329",
    id: "Fill-36",
    fill: "#4F4B67",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8454272,28 L62.8460748,27.9980974 C63.6128905,20.525413 61.8901458,10.6948026 49,7 C49,7 63.2359591,15.8006825 62.8454272,28",
    id: "Fill-37",
    fill: "#4F4B67",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6785752,43.5536186 C18.1100236,48.1440448 17.0910869,53.4084026 13.4023116,55.3115752 C9.71419659,57.2147478 4.75290603,55.0365277 2.32145762,50.4461015 C-0.10999078,45.8563271 0.908945908,40.5919692 4.59706088,38.6887966 C8.28583622,36.7849723 13.2471268,38.9631924 15.6785752,43.5536186",
    id: "Fill-38",
    fill: "#E5726D",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,52 C13.9850218,51.8145157 13.9475763,51.6536761 13.9271514,51.4740287 C13.9557462,51.603738 13.9734477,51.7120453 13.9836601,51.798302 C13.9598312,50.8689346 13.8175381,50.1075408 13.5697168,49.5108779 C11.5891885,41.7795531 4,41 4,41 C7.84463508,43.2115441 10.2445534,45.649431 11.7314815,47.670951 C9.00272331,46.6118743 4.78431373,48.8539001 4.78431373,48.8539001 C9.78907952,47.5898827 12.065768,48.636637 13.1108388,49.8507163 C13.7998366,51.1594835 14,52 14,52",
    id: "Fill-39",
    fill: "#DF4F4B",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2992369,54 C12.2992369,54 6.63750329,38.0305999 13.0830072,29 L17,40.8483731 L12.2992369,54",
    id: "Fill-40",
    fill: "#302C3F",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3213868,43.5536186 C49.8900084,48.1440448 50.9089157,53.4084026 54.5975849,55.3115752 C58.2855937,57.2147478 63.2467414,55.0365277 65.6781199,50.4461015 C68.1101586,45.8563271 67.0912513,40.5919692 63.4025821,38.6887966 C59.7139129,36.7849723 54.7527652,38.9631924 52.3213868,43.5536186",
    id: "Fill-41",
    fill: "#E5726D",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54,52 C54.0149782,51.8145157 54.0517429,51.6536761 54.0721678,51.4740287 C54.043573,51.603738 54.0265523,51.7120453 54.0163399,51.798302 C54.0401688,50.8689346 54.1824619,50.1075408 54.4302832,49.5108779 C56.4108115,41.7795531 64,41 64,41 C60.1553649,43.2115441 57.7554466,45.649431 56.2685185,47.670951 C58.9972767,46.6118743 63.2150054,48.8539001 63.2150054,48.8539001 C58.2102397,47.5898827 55.9349129,48.636637 54.889842,49.8507163 C54.2008442,51.1594835 54,52 54,52",
    id: "Fill-42",
    fill: "#DF4F4B",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8043108,56 C54.8043108,56 61.8446476,51.6958491 57.6855875,32 L49,34.7561608 L54.8043108,56",
    id: "Fill-43",
    fill: "#302C3F",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3578746,47.1331207 L53.7238844,28.1418149 C53.4511177,31.734497 51.0001324,31.9180262 51.0001324,31.9180262 C51.8171275,30.0484055 49.9103706,24.5484726 49.9103706,24.5484726 C49.0933755,27.8850062 44.1907523,27.6281974 44.1907523,27.6281974 C48.2757278,21.7255567 44.1907523,13 44.1907523,13 C43.6458714,23.0089404 36.0194962,26.8584312 22.9456169,31.9180262 C13.1840915,35.6955578 11.3197505,44.7221551 11,49.0542352 C11.3523781,61.0014546 14.8702859,72 33.5998334,72 C49.9195063,72 54.6172281,64.2376413 55.8375004,54.7931521 C56.1676917,52.234967 55.9882399,49.6332102 55.3578746,47.1331207",
    id: "Fill-44",
    fill: "#EE9F79",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("image", {
    id: "Image-46",
    fill: "none",
    x: 27,
    y: 57,
    width: 12,
    height: 4,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAMCAYAAAAOCs/+AAAEGWlDQ1BrQ0dDb2xvclNwYWNlR2VuZXJpY1JHQgAAOI2NVV1oHFUUPrtzZyMkzlNsNIV0qD8NJQ2TVjShtLp/3d02bpZJNtoi6GT27s6Yyc44M7v9oU9FUHwx6psUxL+3gCAo9Q/bPrQvlQol2tQgKD60+INQ6Ium65k7M5lpurHeZe58853vnnvuuWfvBei5qliWkRQBFpquLRcy4nOHj4g9K5CEh6AXBqFXUR0rXalMAjZPC3e1W99Dwntf2dXd/p+tt0YdFSBxH2Kz5qgLiI8B8KdVy3YBevqRHz/qWh72Yui3MUDEL3q44WPXw3M+fo1pZuQs4tOIBVVTaoiXEI/MxfhGDPsxsNZfoE1q66ro5aJim3XdoLFw72H+n23BaIXzbcOnz5mfPoTvYVz7KzUl5+FRxEuqkp9G/Ajia219thzg25abkRE/BpDc3pqvphHvRFys2weqvp+krbWKIX7nhDbzLOItiM8358pTwdirqpPFnMF2xLc1WvLyOwTAibpbmvHHcvttU57y5+XqNZrLe3lE/Pq8eUj2fXKfOe3pfOjzhJYtB/yll5SDFcSDiH+hRkH25+L+sdxKEAMZahrlSX8ukqMOWy/jXW2m6M9LDBc31B9LFuv6gVKg/0Szi3KAr1kGq1GMjU/aLbnq6/lRxc4XfJ98hTargX++DbMJBSiYMIe9Ck1YAxFkKEAG3xbYaKmDDgYyFK0UGYpfoWYXG+fAPPI6tJnNwb7ClP7IyF+D+bjOtCpkhz6CFrIa/I6sFtNl8auFXGMTP34sNwI/JhkgEtmDz14ySfaRcTIBInmKPE32kxyyE2Tv+thKbEVePDfW/byMM1Kmm0XdObS7oGD/MypMXFPXrCwOtoYjyyn7BV29/MZfsVzpLDdRtuIZnbpXzvlf+ev8MvYr/Gqk4H/kV/G3csdazLuyTMPsbFhzd1UabQbjFvDRmcWJxR3zcfHkVw9GfpbJmeev9F08WW8uDkaslwX6avlWGU6NRKz0g/SHtCy9J30o/ca9zX3Kfc19zn3BXQKRO8ud477hLnAfc1/G9mrzGlrfexZ5GLdn6ZZrrEohI2wVHhZywjbhUWEy8icMCGNCUdiBlq3r+xafL549HQ5jH+an+1y+LlYBifuxAvRN/lVVVOlwlCkdVm9NOL5BE4wkQ2SMlDZU97hX86EilU/lUmkQUztTE6mx1EEPh7OmdqBtAvv8HdWpbrJS6tJj3n0CWdM6busNzRV3S9KTYhqvNiqWmuroiKgYhshMjmhTh9ptWhsF7970j/SbMrsPE1suR5z7DMC+P/Hs+y7ijrQAlhyAgccjbhjPygfeBTjzhNqy28EdkUh8C+DU9+z2v/oyeH791OncxHOs5y2AtTc7nb/f73TWPkD/qwBnjX8BoJ98VQNcC+8AAAA4ZVhJZk1NACoAAAAIAAGHaQAEAAAAAQAAABoAAAAAAAKgAgAEAAAAAQAAACagAwAEAAAAAQAAAAwAAAAALEs1xAAAADBJREFUOBFjfJAf9J9hEAKmQegmsJNGHUZqzIyG2GiIkRoCpKofTWOjIUZqCJCqHgArKQK41rouBgAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46,41.9996913 C46,43.6569929 45.3279152,45 44.5003534,45 C43.6720848,45 43.0007067,43.6569929 43,41.9996913 C43.0007067,40.3430071 43.6720848,39 44.5003534,39 C45.3279152,39 46,40.3430071 46,41.9996913",
    id: "Fill-47",
    fill: "#150E18",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,42 C21.9992937,43.6574722 22.6715367,45 23.5,45 C24.3284638,45 25,43.6574722 25,42 C25,40.3425278 24.3284638,39 23.5,39 C22.6715367,39 21.9992937,40.3425278 22,42",
    id: "Fill-48",
    fill: "#150E18",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,38 C18,38 26.0006797,35.4583515 30,35.6851182 C30,35.6851182 29.3250637,31.3173664 24.548853,32.092097 C18.8856415,33.0104687 18,38 18,38",
    id: "Fill-49",
    fill: "#302C3F",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,36 C50,36 41.8791864,34.4470675 38,35.1258241 C38,35.1258241 38.1330733,30.8024964 42.892282,31.0070353 C48.5335191,31.2493553 50,36 50,36",
    id: "Fill-50",
    fill: "#302C3F",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5817824,52 C22.4969447,52 22.4102492,51.9810822 22.3297463,51.9412897 C22.0393165,51.800385 21.9179428,51.4500803 22.0585133,51.1584859 L23.8939802,47.330575 C24.0339314,47.0396329 24.3813326,46.9182983 24.6705239,47.0578983 C24.9609537,47.198803 25.0817081,47.5491077 24.9417568,47.8400498 L23.10629,51.6679607 C23.0053517,51.8786654 22.7979018,52 22.5817824,52",
    id: "Fill-51",
    fill: "#DF4F4B",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.581705,52 C18.4968726,52 18.4108018,51.9817294 18.3296847,51.9419314 C18.0392731,51.8010072 17.9185263,51.4506541 18.0578495,51.1590193 L19.8932012,47.330579 C20.0331436,47.0395966 20.3817614,46.9188977 20.6703153,47.0572122 C20.9607269,47.1987888 21.0814737,47.5491419 20.9421505,47.8401243 L19.1067988,51.6685646 C19.0058669,51.878646 18.79843,52.0006498 18.581705,52",
    id: "Fill-52",
    fill: "#DF4F4B",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.418407,52 C46.2016382,52 45.9941596,51.8786581 45.8932073,51.6679408 L44.0574855,47.8404535 C43.9187535,47.5494941 44.0395247,47.198516 44.3293755,47.0576029 C44.6198456,46.9186469 44.9666756,47.0393364 45.1066463,47.3309483 L46.9417487,51.1590879 C47.0817194,51.4506998 46.9609482,51.8010255 46.6704781,51.9419386 C46.5893447,51.9817335 46.5032565,52 46.418407,52",
    id: "Fill-53",
    fill: "#DF4F4B",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.41796,52 C49.2012107,52 48.9937506,51.878012 48.8928074,51.6686103 L47.0578698,47.8406675 C46.918531,47.5490706 47.0392913,47.1987629 47.3291161,47.0572047 C47.6195601,46.9189082 47.966359,47.0395915 48.1063171,47.330536 L49.941874,51.1591312 C50.0818321,51.450728 49.9604525,51.8010357 49.6700084,51.9419416 C49.5888823,51.9810821 49.5028018,52 49.41796,52",
    id: "Fill-54",
    fill: "#DF4F4B",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37,47.8796809 C37,49.602351 35.8809174,51 34.5002825,51 C33.1190826,51 32,49.602351 32,47.8796809 C32,46.1552477 33.1190826,44 34.5002825,44 C35.8809174,44 37,46.1552477 37,47.8796809",
    id: "Fill-55",
    fill: "#DF4F4B",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3428024,56 C29.243527,56 25.450036,53.2580713 25.2527462,53.1114086 C24.9654871,52.8995625 24.9153613,52.5084619 25.1422125,52.2374679 C25.368421,51.9676809 25.7854929,51.9212076 26.072752,52.1318466 C26.1286615,52.1734916 31.7678083,56.2208994 40.1683696,54.1537399 C40.5211778,54.0692428 40.8849108,54.2660002 40.9780933,54.5991599 C41.0712758,54.9323196 40.8585626,55.272722 40.5038266,55.3596332 C38.6446754,55.8171243 36.9166223,56 35.3428024,56",
    id: "Fill-56",
    fill: "#DF4F4B",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-57",
    fill: "#F0AC8A",
    fillRule: "evenodd",
    points: "44.511 13.4885 44.496 13.4565 44.489 13.5435 44.511 13.4885"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.96999,67.4124218 C22.2769315,67.4124218 16.150415,63.5921134 13,58 C15.0694153,65.9868239 20.4954848,72 33.9604123,72 C47.7094773,72 53.0250844,66.1719578 55,58.4491335 C51.8961963,63.778584 45.7977743,67.4124218 33.96999,67.4124218",
    id: "Fill-58",
    fill: "#F0AA87",
    fillRule: "evenodd"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar1);
export default __webpack_public_path__ + "static/media/avatar-1.e18c937d0a33154687422e5da407f480.svg";
export { ForwardRef as ReactComponent };